namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonSumBillForm {
        RefundId: Serenity.IntegerEditor;
        RefundReason: Serenity.StringEditor;
        BillQty: Serenity.IntegerEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSales: Serenity.DecimalEditor;
        DtList: ReportRefundReasonSumBillDtEditor;
    }

    export class ReportRefundReasonSumBillForm extends Serenity.PrefixedContext {
        static formKey = 'RefundReasonReport.ReportRefundReasonSumBill';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportRefundReasonSumBillForm.init)  {
                ReportRefundReasonSumBillForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = ReportRefundReasonSumBillDtEditor;

                Q.initFormType(ReportRefundReasonSumBillForm, [
                    'RefundId', w0,
                    'RefundReason', w1,
                    'BillQty', w0,
                    'GrossSales', w2,
                    'AllItemDiscount', w2,
                    'NetSales', w2,
                    'DtList', w3
                ]);
            }
        }
    }
}
